(() => {
  if (window.scarpeStockNoticeLoaded) return;
  window.scarpeStockNoticeLoaded = true;
  let cartQuantities = null;
  let cartRevision = 0;
  function stateFor(data, requested, cartQuantity) {
    if (data.available !== 'true') return 'unavailable';
    if (data.tracked !== 'true') return 'confirm';
    const stock = Number(data.stock) || 0;
    const required = requested + cartQuantity;
    if (stock >= required) return 'ready';
    if (data.policy !== 'continue') return 'unavailable';
    return stock > 0 ? 'partial' : 'production';
  }
  function update() {
    document.querySelectorAll('product-info [data-stock-notice]').forEach(notice => {
      const productInfo = notice.closest('product-info');
      const quantityInput = productInfo.querySelector('input[name="quantity"]');
      const requested = Math.max(1, Number(quantityInput?.value) || 1);
      const data = notice.dataset;
      const inCart = cartQuantities ? (cartQuantities[data.variant] || 0) : (Number(data.cartQuantity) || 0);
      const state = stateFor(data, requested, inCart);
      notice.dataset.state = state;
      const label = notice.querySelector('[data-stock-label]');
      if (label && label.textContent !== data[state]) label.textContent = data[state];
    });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="quantity"]')) update();
  });
  const init = () => {
    update();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, update);
      subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
        const revision = ++cartRevision;
        try {
          let cart = event?.cartData;
          if (!Array.isArray(cart?.items)) {
            const response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
            if (!response.ok) return;
            cart = await response.json();
          }
          if (revision !== cartRevision) return;
          cartQuantities = {};
          cart.items.forEach(item => {
            const id = String(item.variant_id);
            cartQuantities[id] = (cartQuantities[id] || 0) + item.quantity;
          });
          update();
        } catch (error) {
          update();
        }
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();